module.exports = __webpack_public_path__ + "static/img/researchInstitutes2.9b955a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/researchInstitutes2.png
// module id = nzEg
// module chunks = 1